import { useContext } from 'react';
import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import Button from '../../layout/Button';
import Loading from '../../ui-elements/Loading';
import BackButton from '../../layout/BackButton';
import AuthContext from '../../../contexts/auth/AuthContext';
import { HELP_DESK_LINK } from '../../../constants/helpDesk';
const SeedTypeSelection = ({ backwardTo }) => {
  const { activeProcessId, backIsAllowed, continueProcess, handleError, isNetworkError } = useContext(ProcessContext);
  const { accessibleSeedTypes } = useContext(AuthContext);
  const { loading } = useContext(UIContext);

  const selectSeedTypeId = async (seedTypeId) => {
    if (!seedTypeId) {
      return;
    };
    try {
      await continueProcess(activeProcessId, seedTypeId);
    } catch (error) {
      if (isNetworkError(error)) {
        handleError(error);
        console.error(error);
      } else {
        handleError(
          error,
          <>We have encountered a problem while continuing the Process.
              Please contact the support team {HELP_DESK_LINK}.</>
        );
        console.error(error);
      }
    }
  };

  return loading ? (
    <Loading fullScreen />
  ) : (
    <div className='seed-selection-container'>
      <div className='seed-selection-content'>
      {accessibleSeedTypes
        ?.filter(seedType => seedType?.seedVariantTypes?.length > 0 && seedType.outdated == undefined)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(seedType => (
          <Button
            key={seedType?.id + '-frontButton'}
            icon='fas fa-leaf'
            className='seed-button'
            label={seedType.name}
            numberBadgeValue={parseInt(seedType?.seedVariantTypes?.length)}
            disabled={seedType?.seedVariantTypes?.length == 0}
            clickHandler={() => selectSeedTypeId(seedType?.id)}
          />
        ))}
      </div>
      <BackButton disabled={!backIsAllowed} navigateTo={backwardTo} />
    </div>
  );
};

export default SeedTypeSelection;